
import { chats } from "../../models/model";
import { ChatActions } from "../interface/reducerType";

import {Types} from '../action/action';



const initialState=  {
  
  xmppDetails:  {
 
    jid: "",
    resourceid: "",
    id: "",
    status: "",
    conference: ""
  },
 
  recentContact:[
  ],
  pinnedContact:[],
  /* isChatWindow:false,
  chatWindowDetails:{}, */
  stickers:[],
  isStickers:false,
  lastArchiveid:"",
  scrollto:"",
  isScroll:false,
  scrollUnread:false,
  countValue:0,
  archiveMessageArray:[],
  archiveMessageArrayNew:[],
  fileList:[],
  isDelete:false,
  isForward:false,
  selectMessageData:[],
  fileUpload:false,
  isTyping : false,
  isSearch: false,
  isTypingGroup: false,
  chatLoader:false,
  TypingUser:[],
  TypingTeamId:[],
  editMessageDetails:{
    isEditing:false,
    message:{
      id: "",
      text:""
    }
  },
  replyMessageDetails:{
    isReply:false,
    replyType: "TEXT",
    replySelectFile: "",
    replyFileType: "",
    replyFileName: "",
    replyFileSize: "",
    replyFileMimeType: "",
    replymessage:{
 
    }
 
  },
  recordingTimer: "00:00:00",
  searchData: "",
  isKey:"",
  isWindowSlide:false,
  isEdit:{},
  isSaveChat:false,
  saveChatData:{},
  isEventviewontoast:false,
  Eventviewontoast:{},
  isTaskviewontoast:false,
  Taskviewontoast:{},
  isNotesviewontoast:false,
  notesviewontoast:{},
  ActiveTab:"1",
  isViewbutton:false,
  audioPermission: false,
  videoPermission: false,
  notifyPermission: false,
  forwardType:"",
  deleteType:"",
  multiOption:false,
  imgIndex:-1,
  chatsummary:{
    fromPerson:"",
    summary:""
  },
  composedMsg:{},
  isAiAssist:false,
  isCaptureAi:false,
  aiRequest:"",
  list:{
    suggestions:[],
    prompt:"",
    error:""
  },
  arrayBuffer:"",
  intent:"",
  aiAssistMessage:""

/*   shareMessageDetails:{
    isShare:false,
    shareMessage:{}
  } */
 
 
};


export const chatReducer = (state: chats = initialState, action: ChatActions) => {
  switch (action.type) {
  case Types.SET_XMPP_DETAILS:
    return {
      ...state, xmppDetails: action.payload.xmppDetails
    };
    
  case Types.GET_STICKERS:
    return {
      ...state, stickers: action.payload.stickers, isStickers:action.payload.isStickers
    };
  case Types.FILE_LIST:
    return {
      ...state, fileList: action.payload.fileList
    };
  case Types.FILE_UPLOAD_PROGRESS_BAR:
    return {
      ...state,  fileUpload: action.payload.fileUpload
    };
  case Types.CHAT_LOAD:
    return {
      ...state,  chatLoader: action.payload.chatLoader
    };
 /*  case Types.SET_RECENT_CHAT:
    return {
      ...state, recentContact: action.payload.recentContact
    };
  case Types.FILE_LIST:
    return {
      ...state, fileList: action.payload.fileList
    };
  case Types.FILE_UPLOAD_PROGRESS_BAR:
    return {
      ...state,  fileUpload: action.payload.fileUpload
    };
  case Types.SET_PINNED_CHAT:
    return {
      ...state, pinnedContact: action.payload.pinnedContact
    }; */

  case Types.STORE_ARCHIVE_MESSAGE:
    return {
      ...state, archiveMessageArray: action.payload.archiveMessageArray,
      lastArchiveid:action.payload.lastArchiveid, scrollto:action.payload.scrollto || ""
    };
    case Types.STORE_ARCHIVE_MESSAGE_NEW:
      return {
        ...state, archiveMessageArrayNew: action.payload.archiveMessageArrayNew
      };
  case Types.EDIT_MESSAGE_WINDOW:
    return {
      ...state, editMessageDetails: action.payload.editMessageDetails
    };

  case Types.DELETE_MESSAGE_WINDOW:
    return {
      ...state, isDelete: action.payload.isDelete,deleteType:action.payload.deleteType
    };
  case Types.FORWARD_MESSAGE_WINDOW:
    return {
      ...state, isForward: action.payload.isForward,forwardType:action.payload.forwardType
    };
  case Types.SELECT_MESSAGE_ARRAY:
    return {
      ...state, selectMessageData: action.payload.selectMessageData
    };
  case Types.REPLY_MESSAGE_WINDOW:
    return {
      ...state, replyMessageDetails: action.payload.replyMessageDetails
    };
    ;
 /*  case Types.OPEN_CHAT_WINDOW:
    return {
      ...state, isChatWindow: action.payload.isChatWindow, chatWindowDetails:action.payload.chatWindowDetails
    };*/
  case Types.SET_TYPING_STATUS:
    return {
      ...state, isTyping: action.payload.isTyping,
      isTypingGroup: action.payload.isTypingGroup,
      TypingUser:action.payload.TypingUser,
      TypingTeamId:action.payload.TypingTeamId
    };
  case Types.AUDIO_RECORD_TIMER:
    return {
      ...state, recordingTimer:action.payload.recordingTimer
    };
    case Types.SCROLL_UNREAD:
      return {
        ...state, scrollUnread:action.payload.scrollUnread
      };
      case Types.COUNT_VALUE:
        return {
          ...state, countValue:action.payload.countValue
        };
  case Types.CHAT_SEARCH_STORE:
    return {
      ...state, searchData: action.payload.searchData,isSearch: action.payload.isSearch
    };

  case Types.LOAD_PAGINATION_MESSAGE:
    return {
      ...state, isScroll: action.payload.isScroll
    };
    case Types.CHAT_WINDOW_SLIDE_OPEN:
      return {
        ...state, isWindowSlide: action.payload.isWindowSlide,isKey:action.payload.isKey,isEdit:action.payload.isEdit
      };
    case Types.SAVE_CHAT_MESSAGE:
      return {
        ...state, isSaveChat: action.payload.isSaveChat,saveChatData:action.payload.saveChatData
      };
    case Types.VIEW_EVENTS_FROM_TOAST:
      return {
        ...state, isEventviewontoast: action.payload.isEventviewontoast,
        isTaskviewontoast:action.payload.isTaskviewontoast,
        Taskviewontoast:action.payload.Taskviewontoast,
        isNotesviewontoast:action.payload.isNotesviewontoast,
        notesviewontoast:action.payload.notesviewontoast,
        Eventviewontoast:action.payload.Eventviewontoast,
        isViewbutton:action.payload.isViewbutton
      };
      case Types.TAB_CHANGE:
        return {
          ...state, ActiveTab: action.payload.ActiveTab
        }; 
        case Types.ENABLE_NOTIFICATION:
          return {
            ...state,notifyPermission: action.payload.notifyPermission
          };
          case Types.AUDIO_NOTIFICATION:
            return {
              ...state,audioPermission: action.payload.audioPermission
            };
            case Types.VIDEO_NOTIFICATION:
        return {
          ...state,videoPermission: action.payload.videoPermission
        }; 
        case Types.MULTI_SELECT_OPTION:
          return {
            ...state,multiOption: action.payload.multiOption
          };   
        case Types.SET_IMG_INDEX:
          return {
              ...state,imgIndex: action.payload.imgIndex
            };
        case Types.STORE_CHAT_SUMMARY:
          return {
              ...state,chatSummary: action.payload.chatSummary
              };  
        case Types.STORE_COMPOSED_MSG:
          return{
            ...state,composedMsg:action.payload.composedMsg
          }
        case Types.AI_ASSIST:
          return{
            ...state,isAiAssist:action.payload.isAiAssist,isCaptureAi:action.payload.isCaptureAi,aiRequest:action.payload.aiRequest,list:action.payload.list
          }
        case Types.SET_ARR_BUFFER:
          return{
            ...state,arrayBuffer:action.payload.arrayBuffer,aiSessionId:action.payload.aiSessionId,intent:action.payload.intent,aiAssistMessage:action.payload.aiAssistMessage
          }
  default:
    return state;
  }
};
